<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    let myData1 = [
      {
        value: 1307.07,
        name: "农机",
      },
      {
        value: 1922.77,
        name: "种子",
      },
      {
        value: 930.6,
        name: "打药",
      },
      {
        value: 539.56,
        name: "灌溉",
      },
      {
        value: 539.56,
        name: "化肥",
      },
    ];
    let colorA = ["#00FFFF", "#006CED", "#FFE000", "#FF0400","#00FFFF"];
    let title = "农资";
    this.state.chart.setOption({
      title: {
        text: "" + title + "\n" + "费用统计",
        top: "36%",
        left: "22.5%",
        textStyle: {
          fontSize: 36,
          color: "#ffffff",
        },
      },
      legend: {
        orient: "vertical",
        icon: "circle",
        right: "8%",
        y: "center",
        itemWidth: 40,
        itemHeight: 50,
        itemGap: 100,
        align: "left",
        textStyle: {
          rich: {
            name: {
              // width: '45%',
              fontSize: 34,
              color: "#fff",
              lineHeight:60,
              padding: [20, 0, 0, 15],
            },
            value: {
              fontSize: 34,
              padding: [20, 5, 0, 15],
              color: "#00E1EF",
            },
          },
        },
        formatter: function (name) {
          let res = myData1.filter((v) => v.name === name);
          res = res[0] || {};
          const p = res.value;
          return "{name|" + name + "}"+"\n" + "{value|" + p + "万}";
          // return "{name|" + name + "}";
        },
      },
      tooltip: {
        show: false,
        confine: true,
        trigger: "item",
        formatter: "{b} : {c}",
      },
      series: [
        {
          avoidLabelOverlap: false,
          type: "pie",
          roseType: "area", // 玫瑰图
          center: ["25%", "45%"],
          radius: ["46%", "85%"],
          color: colorA,
          itemStyle: {
            normal: {
              borderColor: "#050F20",
              borderWidth: 3,
            },
          },
          label: {
            normal: {
              //   formatter: '{b}\n{d}%\t{c}',
              formatter: "{b|{b}}\n{d|{d}%}",
              rich: {
                icon: {
                  fontSize: 30,
                },
                d: {
                  fontSize: 30,
                  padding: [5, 0, 0, 0],
                  color: "#fff",
                },
                b: {
                  fontSize: 30,
                  padding: [0, 0, 5, 0],
                  color: "#fff",
                },
              },
            },
          },
          labelLine: {
            normal: {
              length: 10,
              length2: 25,
            },
          },
          data: myData1,
        },
      ],
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
